import { LoginActionTypes, LoginAction, LoginState } from '../../types/login'

const initialState = {
  inProgress: false,
  value: 0,
  isResetForm: false,
  isTabChanged: false,
  tabValue: '1',
  lang: 'az',
  notify: true
}

const loginReducer = (state = initialState, action: LoginAction): LoginState => {
  switch (action.type) {
    case LoginActionTypes.CHANGE_ROUTE:
      return {
        ...state,
        value: action.payload,

      };
    case LoginActionTypes.RESET_FORM:
      return {
        ...state,
        isResetForm: true,
      };
    case LoginActionTypes.CHANGE_TAB:
      return {
        ...state,
        isTabChanged: true,
        tabValue: action.payload
      };
    case LoginActionTypes.CHANGE_LANG:
      return {
        ...state,
        lang: action.payload
      };
    case LoginActionTypes.SIGN_OUT:
      return {
        ...state,
        authorized: false,
        authorizedAsan: false
      }
    case LoginActionTypes.REMOVE_NOTIFICITAION:
      return {
        ...state,
        notify: false
      }
    case LoginActionTypes.UNAUTH_USER:
      return {
        ...state,
        authorized: false,
        authorizedAsan: false
      }
    default:
      return state;
  }
};

export default loginReducer